import { jsxs as f, Fragment as p, jsx as r } from "react/jsx-runtime";
import { useState as g, useEffect as k } from "react";
import { Icon as c } from "../../../../components/Icon/index.js";
import { ToolbarButton as m } from "../../styles.js";
import { RotateLeft as x, RotateRight as R } from "@pelando/fontawesome/icons";
import { useTranslation as j } from "../../../../hooks/useTranslation/index.js";
function F({ quill: t }) {
  var n, s, d, a;
  const { t: o } = j("common"), [e, y] = g({
    redo: !!((s = (n = t == null ? void 0 : t.history) == null ? void 0 : n.stack) != null && s.redo.length),
    undo: !!((a = (d = t == null ? void 0 : t.history) == null ? void 0 : d.stack) != null && a.undo.length)
  });
  return k(() => {
    const h = () => {
      y((b) => ({
        ...b,
        redo: !!(t == null ? void 0 : t.history).stack.redo.length,
        undo: !!(t == null ? void 0 : t.history).stack.undo.length
      }));
    };
    return t == null || t.on("text-change", h), () => {
      t == null || t.off("text-change", h);
    };
  }, [t]), /* @__PURE__ */ f(p, { children: [
    /* @__PURE__ */ r(
      m,
      {
        type: "button",
        id: "undo-button",
        disabled: e.undo ? void 0 : !0,
        onClick: () => t == null ? void 0 : t.history.undo(),
        title: o("history-buttons-undo"),
        children: /* @__PURE__ */ r(c, { icon: x, "aria-label": o("history-buttons-undo") })
      }
    ),
    /* @__PURE__ */ r(
      m,
      {
        type: "button",
        id: "redo-button",
        disabled: e.redo ? void 0 : !0,
        onClick: () => t == null ? void 0 : t.history.redo(),
        title: o("history-buttons-remake"),
        children: /* @__PURE__ */ r(c, { icon: R, "aria-label": o("history-buttons-remake") })
      }
    )
  ] });
}
export {
  F as HistoryButtons
};
